<template>
  <div class="ruleContent">
    <p class="title">投保须知</p>
    <p>1.本产品由北部湾财产保险股份有限公司承保，升华茂林保险销售有限公司四川分公司为唯一代理商，云南祐祉商务信息咨询有限公司（指定投保人）旗下（学驾易）为唯一服务科技平台。</p>
    <p>2. 适用条款</p>
    <p>本保单适用《北部湾财险驾驶培训人员重新报名费用损失保险》（2021版）条款
      ) </p>
    <p> 。请投保人了解、同意并确认上述条款内容，特别是保险责任及责任免除的部分。购买本保险产品即表示投保人同意接受本产品条款及投保须知的全部内容。</p>
    <p>3.如实告知</p>
    <p>根据《保险法》相关要求， 投保人在投保时须保证投保信息 真实有效， 如投保人未能履行如实告知义务，须承担相应后果：</p>
    <p>( 1 ) 投保人故意或者因重大过失未履行前款规定的如实告 知义务，足以影响保险人决定是否同意承保或者提高保险费率的， 保险人有权解除合同。</p>
    <p>(2) 投保人故意不履行如实告知义务的， 保险人对于合同 解除前发生的保险事故， 不承担赔偿或者给付保险金的责任， 并 不退还保险费。</p>
    <p>(3) 投保人因重大过失未履行如实告知义务， 对保险事故 的发生有严重影响的， 保险人对于合同解除前发生的保险事故， 不承担赔偿或者给付保险金的责任， 但应当退还保险费。</p>
    <p></p>
    <p>4.产品介绍</p>
    <p>(1) 被保险人： 学员；</p>
    <p>(2) 投保人： 云南祐祉商务信息咨询有限公司；</p>
    <p>(3) 承保学员年龄： 18-60 周岁 (含) ；</p>
    <p>(4) 承保范围： 本保单仅限于首次申领 C1、C2 证的驾校学 员 (准驾车型以交警部门通告为准)</p>
    <p>(5) 投保时间： 须在首次科目一考试前至少 1 天投保；</p>
    <p>(6) 本保险同一学员限投保一份， 多投无效；</p>
    <p>(7) 学员因缺考造成的考试不通过， 不承担赔偿责任 (科 目一 0 分， 科 目 四 0 分， 不予赔付) ；</p>
    <p>(8) 保险期限内， 学员提前取得驾驶证， 则该学员的保险 责任自行终止(取得驾驶证之 日 24 时止)；</p>
    <p>(9) 学员因任何原因导致报考驾校与投保驾校不符所产生 的补考费用不予赔付。</p>
    <p>(10)本保险主险仅承保因被保险人过失导致保单列明的学 员死亡及残疾，被保险人依法应承担的经济赔偿责任；</p>
    <p>(11) 本保单赔偿项目限于学员考试不过产生的补考费 用，赔偿限额不超过方案列明限额。</p>
    <p></p>
    <p>(12)如果在异地考试，以投保地该科目赔付标准与考试地 该科目赔付标准取低进行赔付。</p>
    <p>(13) 考试成绩显示后5 个工作日内须完成报案，超出报 案时间不予赔付。</p>
    <p>(14) 赔偿约定：</p>
    <p>每人限额：科 目二、科 目三、赔付标准( 元 ) 以当地补考费用为标准 。</p>
    <p>科 目二、科 目 三、科 目 四最多赔付 4 次， 累计不超过补考保障限额；</p>
    <p>责任限额： 本保单《北部湾财险驾驶培训人员重新报名费用损失保险》项下： 每人补考费用补偿责任限额为方案列明限额 。</p>
    <p>5.补偿流程</p>
    <p>学员考试未通过挂科后通过学驾易平台在线申请补偿，并提供相应理 赔资料。</p>
    <p>具体需提供材料如下：</p>
    <p>( 1 )保单信息： 学员姓名、身份证号、手机号、考试省份；</p>
    <p>（2）补偿科目信息： 补偿科目、补偿科目考试日期；</p>
    <p>（3）影像信息：授权书扫描件；</p>
    <p>(2)其他材料：驾校赔款收款账户信息、学员122网站登陆账号及密码。</p>
    <p>6.保单及发票</p>
    <p>本保险为您提供电子保单及电子发票，根据国家相关法律法规规定，数据电文是合法的合同表现形式，电子保险凭证、电子发票具有法律效力。</p>
    <p>7.相关授权</p>
    <p>
      为提供保险服务，及为依法履行反洗钱和反恐怖融资职责或者义务，您（投保人/被保险人）同意鼎和财产保险股份有限公司及其服务必要而委托的第三方基于为您提供服务、服务管控及洗钱风险管控等用途，在承保前后可以收集、整理、保存、加工、核实、调查、提供和使用您授权的及享受鼎和财产保险股份有限公司服务必要的相关信息，但法律禁止的除外北部湾财产保险股份有限公司及其委托的第三方对上述信息负有保密义务。</p>
    <p>8.偿付能力告知</p>
    <p>北部湾财产保险股份有限公司最近季度的综合偿付能力充足，风险综合评级为B 级，综合偿付能力充足率和风险综合评级均达到监管要求。</p>
  </div>
</template>

<script>
export default {
  name: "tbxz"
}
</script>

<style lang="scss" scoped>
.ruleContent {
  padding: 9px;
  background: #fff;
  min-height: 100%;
  font-size: 14px;
  color: #0C0C0C;
  line-height: 25px;
  //width: 100%;
  max-height: 500px;
  overflow: auto;
  margin: 0 auto;
  .title {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    margin: 10px 0;
  }
}
</style>



// WEBPACK FOOTER //
// tbxz.vue?4b4c19b1